import { Component, Input, OnInit } from '@angular/core';
import { PremiseFlat } from "../../../_model/store-response/premise-flat";
import { PremiseRow } from "../../../_model/store-response/premise-row";
import { StoreConfig } from "../../../_model/store-response/store-config";
import { StoreService } from "../../../service/store.service";
import { StoreStateService } from "../store-state.service";
import { UpdateDialogComponent } from "./update-dialog/update-dialog.component";
import { UpdateResult } from "./update-dialog/update-result";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; // Import the module
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StoreConfigComponent } from '../store-config/store-config.component';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
@Component({
  selector: 'app-premise',
  templateUrl: './premise.component.html',
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule, MatFormFieldModule,
    StoreConfigComponent, MatCardModule, MatTooltipModule, MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule],
  styleUrls: ['./premise.component.scss']
})
export class PremiseComponent implements OnInit {

  isLoading = false;
  @Input() premiseRow!: PremiseRow;

  constructor(private dialog: MatDialog,
              private storeService: StoreService,
              private stateService: StoreStateService) {
  }

  ngOnInit() {
  }

  getPremiseFlat(storeConfig: StoreConfig): PremiseFlat {
    return {
      storeConfigId: storeConfig.storeConfigId,
      createdDate: storeConfig.createdDate,
      deletedDate: storeConfig.deletedDate,
      modifiedDate: storeConfig.modifiedDate,
      premiseDetails: this.premiseRow.premiseDetails,
      serviceCoverDetails: storeConfig.serviceCoverDetails,
      incoming: storeConfig.incoming,
      outgoing: storeConfig.outgoing,
      callouts: storeConfig.callouts
    };
  }

  openDialog() {
    const dialogRef = this.dialog.open(UpdateDialogComponent, {
      width: '300px',
      data: {
        clientRef: this.premiseRow?.premiseDetails.find(s => s.property === 'clientReference')?.value
      }
    });
    this.afterClose(dialogRef);
  }

  private afterClose(dialogRef: MatDialogRef<UpdateDialogComponent, UpdateResult>) {
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
      if (result.toUpdate) {
        let updateItem = this.premiseRow.premiseDetails.find(s => s.property === 'clientReference');
        let index = this.premiseRow.premiseDetails.indexOf(updateItem!);
        this.premiseRow.premiseDetails[index] = {
          property: 'clientReference',
          value: result.clientRef,
          displayName: 'clientReference'
        };
        this.isLoading = true;
        this.storeService.updateClientRef(this.premiseRow.premiseDetails).subscribe(() => {
              this.isLoading = false;
              this.stateService.isStoreChanged(true);
            },
            () => {
              this.isLoading = false;
              this.stateService.isStoreChanged(true);
            })
      }
    }
    });
  }

}
